import {Form} from '@wix/ambassador-forms-v4-form/types'
import {getFormCopyMode, getFormIdsForCopy, resolveFormCopy} from '@wix/wix-events-commons-statics'
import {useCallback} from 'react'
import {useAppProps, useAppSelector} from '../../hooks/runtime'
import {getEvent} from '../../selectors/event'
import {FormViewerContextProps} from './interfaces'

export const useFormCopy = () => {
  const event = useAppSelector(getEvent)
  const appProps = useAppProps() as FormViewerContextProps
  const formsById = appProps.wfConfig?.formsById
  const forms = getFormIdsForCopy(event)
    .map(formId => formsById?.[formId])
    .filter((form): form is Form => Boolean(form))
  const copyMode = getFormCopyMode(event, forms)

  return useCallback(
    (configured: string | undefined | null, translated: string) => resolveFormCopy(copyMode, configured, translated),
    [copyMode],
  )
}
